import { render, staticRenderFns } from "./ConfigAcademicDeleteDialog.vue?vue&type=template&id=df025168"
import script from "./ConfigAcademicDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfigAcademicDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports